import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { serializeSelectedRegionsParam } from 'features/knowledgeDocumentViewer/utils/selectedRegionsParam'
import {
  CLEAR_ALL_VIEWER_PARAMS,
  CLEAR_DOCUMENT_PARAMS,
  searchParamsFromSearchState,
} from 'features/knowledgeDocumentViewer/utils/tabStateUrlHelpers'
import {
  CLEAR_SEARCH_VIEWER_PARAMS,
  type DocumentsSearchParams,
} from 'routes/documents/-searchParams'

type NavigateFn = (options: {
  to: '/documents'
  search: (previous: DocumentsSearchParams) => DocumentsSearchParams
}) => void | Promise<void>

type HistoryPushFn = (href: string) => void

/**
 * Activates the route / documents URL state for a workspace tab.
 */
export function navigateToWorkspaceTab(
  tab: DocumentTab,
  {
    historyPush,
    navigateToDocuments,
  }: {
    historyPush: HistoryPushFn
    navigateToDocuments: NavigateFn
  }
): void {
  const item = tab.history[tab.currentIndex]

  if (item.type === 'destination') {
    historyPush(item.href)
    return
  }

  if (item.type === 'document') {
    void navigateToDocuments({
      to: '/documents',
      search: (previous) => ({
        ...previous,
        ...CLEAR_SEARCH_VIEWER_PARAMS,
        documentID: item.documentId,
        pageNumber: item.pageNumber,
        selectedBoxes: item.selectedBoxIds,
        selectedRegions: serializeSelectedRegionsParam(
          item.regionHighlight?.boxes ?? []
        ),
      }),
    })
    return
  }

  if (item.type === 'search') {
    void navigateToDocuments({
      to: '/documents',
      search: (previous) => ({
        ...previous,
        ...CLEAR_DOCUMENT_PARAMS,
        ...searchParamsFromSearchState(item.searchState),
      }),
    })
    return
  }

  void navigateToDocuments({
    to: '/documents',
    search: (previous) => ({
      ...previous,
      ...CLEAR_ALL_VIEWER_PARAMS,
    }),
  })
}
